import script from "./LoginCallbackPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginCallbackPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginCallbackPage.vue?vue&type=style&index=0&id=f8f3d4de&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8f3d4de"]])

export default __exports__